module.exports = __webpack_public_path__ + "img/JinTianGroup-icon.57ad88de.png";